import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EncryptDecryptService } from "../services/encrypt-decrypt.service";
import { VariablesGlobales } from '../services/globals';

@Component({
  selector: 'app-add-edit-form',
  templateUrl: './add-edit-form.component.html',
  styleUrls: ['./add-edit-form.component.css']
})
export class AddEditFormComponent implements OnInit {

  addEditJobForm: FormGroup;
  emploiFonction: Fonction[] = [];
  posteContrat: Contrat[] = [];
  region: Region[] = [];

  jsonData: string;
  apikey: string;

  constructor(public param: VariablesGlobales, private encdec: EncryptDecryptService, private http: HttpClient, private fb: FormBuilder,) { }

  ngOnInit(): void {
    this.apikey = localStorage.getItem('apikey');
    this.createForm();
    this.getInfoJA();
  }

  getInfoJA() {
    this.http.get('https://api.sitederecrutement.com/Home/getinfos?apikey=' + this.apikey, { responseType: "text" }).subscribe(
      result => {
        //console.log(this.encdec.getDecrypt(result));
        this.jsonData = this.encdec.getDecrypt(result);
        let jsonObject: any = JSON.parse(this.jsonData);

        this.emploiFonction = jsonObject.fonctions;
        this.posteContrat = jsonObject.contrats;
        this.region = jsonObject.regions;

        //console.log(this.emploiFonction);
        //console.log(this.posteContrat);
      }
    )
  }

  getPosteContrat() {
    return this.posteContrat;
  }

  private createForm() {
    this.addEditJobForm = this.fb.group({
      name: ['', Validators.required],
      mail: ['', Validators.required],
      fonctionName: ['', Validators.required],
      regionName: ['', Validators.required],
      jobalert_portable: ['', Validators.nullValidator]
    });
  }

}
interface Contrat {
  idtype_contrat: number;
  typecontrat: string;
}

interface Fonction {
  idfonction: number;
  fonction: string;
}

interface Region {
  idregion: number;
  region: string;
}
